import { COLOR_DARK } from "./COLORS";

export const CONTENT_STYLES = { background: COLOR_DARK, overflow: "hidden" };
